import type {SketchLineObject} from '../../../../../mesh/sketch';
import {SketchRelationKind} from '../../relation-compatibility/SketchRelationKinds';
import {SketchLineRelationConstraint} from './SketchLineRelationConstraint';

let count = 0;

/**
 * 判断对象是否为竖直关系。
 * @param value 待判断对象。
 * @returns 是否为竖直关系。
 */
export function isLineVerticalConstraint(value: object): value is LineVerticalConstraint {
    return Reflect.get(value, 'isLineVerticalConstraint') === true;
}

/**
 * 直线竖直关系定义。
 *
 * 几何计算由统一参数公式完成；本类只保存关系类型、目标绑定与显示身份。
 */
export class LineVerticalConstraint extends SketchLineRelationConstraint<SketchLineObject> {
    /** 运行时类型标记。 */
    public readonly isLineVerticalConstraint = true;
    /** 关系类型。 */
    public relationType = SketchRelationKind.Vertical;

    public constructor() {
        super();
        this.name = `${this.baseDisplayName}${count}`;
        count += 1;
    }

    /** 基础显示名。 */
    public get baseDisplayName(): string {
        return '竖直';
    }
}
